export const carReferenceBrandFeatureKey = 'carReferenceBrand';

export type CarReferenceBrandModel = {
  id: number;
  name: string;
};
